import { getField, updateField } from 'vuex-map-fields'
import api from '../api'
import countries from '../../json/countries.json'
import countryZones from '../../json/country_zones.json'

export const state = {
    countryList: countries,
    countryLoading: false,

    countryZoneList: countryZones,
    countryZoneLoading: false,

    countryPartnerList: [],
    countryPartnerLoading: false,

    partnerList: [],
    partnerLoading: false,

    sessionTypeList: [
        { type: 'research', content: 'Research' },
        { type: 'corporate', content: 'Corporate' },
        { type: 'movie', content: 'Movie' },
        { type: 'music', content: 'Music' },
        { type: 'fitness2', content: 'Fitness II' },
        { type: 'detailed emotion', content: 'Detailed emotion' },
        { type: 'video', content: 'Video' },
        { type: 'eve one to one', content: 'EVE One to One' },
        { type: 'eve group', content: 'EVE Group' },
        { type: 'sleep session', content: 'Sleep Session' },
        { type: 'video rating', content: 'Video Rating' },
        { type: 'pure ppi', content: 'Pure PPI' },
    ],
    sessionTypeLoading: false,

    companyTypeList: [{ name: 'Co-working' }, { name: 'School' }],
    companyTypeLoading: false,
}

export const actions = {
    // async getCountryList({ state }) {
    //     state.countryLoading = true

    //     const { data } = await api('get', `/universal/country`)
    //     state.countryList = data.data

    //     state.countryLoading = false
    // },

    async getCountryZone({ state }, payload) {
        state.countryZoneLoading = true
        state.countryZoneList = countryZones.filter((x) => x.name === payload)
        state.countryZoneLoading = false
    },

    async getPartnerCountryList({ state }) {
        state.countryPartnerLoading = true

        const { data } = await api('get', `/cms/admin/available-countries`)
        state.countryPartnerList = data.data

        state.countryPartnerLoading = false
    },

    async getPartnerList({ state }, payload) {
        state.partnerLoading = true

        const { data } = await api(
            'get',
            `/cms/admin/partner?country=${payload}`
        )
        state.partnerList = data.data
        state.partnerLoading = false
    },

    // async getSessionTypeList({ state }) {
    //     state.sessionTypeLoading = true

    //     const { data } = await api('get', `/universal/session-type?language=english`)
    //     state.sessionTypeList = data.data

    //     state.sessionTypeLoading = false
    // },

    // async getCompanyTypeList({ state }) {
    //     state.companyTypeLoading = true

    //     const { data } = await api('get', `/universal/company-type?language=english`)
    //     state.companyTypeList = data.data

    //     state.companyTypeLoading = false
    // },
}

export const mutations = {
    updateField,
}

export const getters = {
    getField,
}

export default {
    state,
    actions,
    mutations,
    getters,
}
